import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { IpService } from '../services/ip.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class IpInterceptor implements HttpInterceptor {
	private ipService = inject(IpService);
	private destroyRef = inject(DestroyRef);

	private ip: string = null;

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const ipCheckEnabled: boolean = environment.ipCheckEnabled;
		const isApiUrl: boolean = request.url.startsWith(environment.apiUrl);
		if (ipCheckEnabled && isApiUrl) {
			this.ip = localStorage.getItem('ip');
			if (!this.ip) {
				this.ipService
					.getIpAddress()
					.pipe(takeUntilDestroyed(this.destroyRef))
					.subscribe((result: any) => {
						this.ip = result.ip;
						localStorage.setItem('ip', this.ip);
					});
			}

			request = request.clone({
				setHeaders: {
					Ip: this.ip !== null ? this.ip : 'null'
				}
			});
		}
		return next.handle(request);
	}
}
